import { Platform } from 'react-native';
import { JDJumping } from '@jdreact/jdreact-core-lib';

/**
 * 此处没有做Platform判断，因此需要自己加web平台判断；
 * 用于判断ua
 */
export function uaType() {
    const ua = navigator.userAgent;
    if (/jdapp/i.test(ua)) {
        return 'app';
    } else if (/MicroMessenger/i.test(ua)) {
        return 'wechat';
    } else if (/QQ/i.test(ua)) {
        return 'qq';
    }
    return 'mobile';
}

/**
 * 格式化跳转链接
 * @param {*} url
 */
export function formatJumpUrl(url) {
    let jumpUrl = url;
    if (url && url.length) {
        if (url.startsWith('//')) {
            jumpUrl = `https:${jumpUrl}`;
        }
        if (url.startsWith('http://')) {
            jumpUrl = url.replace('http://', 'https://');
        }
        return jumpUrl;
    }
    return '';
}

/**
 * 跳转
 * @param {*} jumpUrl 跳转链接
 * @param {*} isNewWebView 是否新开webview（默认新开）
 */
export const jumpByUrl = (jumpUrl, isNewWebView = true) => {
    const formattedJumpUrl = formatJumpUrl(jumpUrl);
    if (formattedJumpUrl && formattedJumpUrl.length) {
        const ua = uaType();
        if (Platform.OS === 'web' && ua === 'app' && isNewWebView) {
            // 在京东app中的h5，使用协议新开webview
            JDJumping.jumpToOpenapp(`openApp.jdMobile://virtual?params={"category":"jump","des":"m","action":"to","url":"${encodeURIComponent(formattedJumpUrl)}"}`);
        } else {
            // 加点延时，否则事件埋点请求会被取消
            setTimeout(() => {
                JDJumping.jumpToWeb(formattedJumpUrl);
            }, 100);
        }
    }
};
